export const withIaCode = (path: string, iaCode?: string | null): string =>
  iaCode ? `${path}&iaCode=${iaCode}` : path;
